module.exports = {"id":"230794","name":"Nacho Gil","rating":"71","photo":"./data/images/photos/2/230794.png","club":{"name":"UD Las Palmas","logo":"./data/images/clubs/UDLasPalmas.png"},"positions":["MD","AD","MOC","MG"],"photoFolderIndex":2}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/NachoGil0.json
// module id = 3120
// module chunks = 0